import callAPI from '../ApiConfig'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

// Auth params from cookies. The backend (src/jwt/auth.js -> validateUser) reads
// these session credentials from the query string when no jwt token is present,
// so every call must include them.
const getAuthParams = () => {
    return {
        username: cookies.get('user_name'),
        user_id: cookies.get('user_id'),
        account_name: cookies.get('account_name'),
        account_id: cookies.get('account_id'),
        sid: cookies.get('sid'),
        baseurl: cookies.get('baseUrl'),
        id: cookies.get('id'),
    }
}

const arrivalValidityRules = async (props) => {
    return await callAPI({
        route: "arrival_validity_rules/",
        method: "get",
        signal: props?.signal,
        params: { ...getAuthParams(), ...props?.params },
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const addArrivalValidityRule = async (props) => {
    return await callAPI({
        route: "arrival_validity_rules/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: { ...getAuthParams(), ...props?.params },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

const editArrivalValidityRule = async (props) => {
    return await callAPI({
        route: "arrival_validity_rules/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: { ...getAuthParams(), ...props?.params },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}

const deleteArrivalValidityRule = async (props) => {
    return await callAPI({
        route: "arrival_validity_rules/" + props?.data?.id,
        method: "delete",
        signal: props?.signal,
        params: { ...getAuthParams(), ...props?.params },
        headers: {}
    })
}

// Backfill/recompute arrival validity for already-arrived transactions.
// data: { transaction_id } OR { arrived_at_from, arrived_at_to, lifecycle_type, destination_geofence_id, limit }
const recomputeArrivalValidity = async (props) => {
    return await callAPI({
        route: "arrival_validity_rules/recompute",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: { ...getAuthParams(), ...props?.params },
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            ...props?.headers
        }
    })
}

const arrivalValidityRuleAPI = {
    arrivalValidityRules: arrivalValidityRules,
    addArrivalValidityRule: addArrivalValidityRule,
    editArrivalValidityRule: editArrivalValidityRule,
    deleteArrivalValidityRule: deleteArrivalValidityRule,
    recomputeArrivalValidity: recomputeArrivalValidity
}
export default arrivalValidityRuleAPI
